require('expose-loader?AcceptAllLineChangesToggle!../../src/app/accept_all_line_changes_toggle');
